import retry from 'promise-retry';
import getRuntimeEnv from "helpers/env";

export default backoff;

async function backoff(cb, msg = '') {
  const options = {
    retries: 2,
    factor: 1,
    minTimeout: 2000,
    maxTimeout: 20000,
  };

  return await retry(async (retry, n) => {
    try {
      const response = await cb();

      if (response.error) {
        throw response;
      }

      return response;
    } catch (response) {
      // The error caught here is an 'intermediate' error and retry will try to dispatch again.
      // We could log and/or report to Sentry here, but we could also choose to only log/report the final error

      // Log a nice informational message to the console
      if (getRuntimeEnv().NODE_ENV === 'development') {
        logRetryMsg(msg, n);
      }

      // Retry the dispatch, if not 404, i.e. no data anyways
      if (response?.payload?.status !== 404) {
        return retry(response);
      } else {
        throw response;
      }
    }
  }, options);
}

function getOrdinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

function logRetryMsg(msg, n) {
  // eslint-disable-next-line no-console
  console.info(msg, getOrdinal(n));
}
